export const getConfigurationByIdField = (id_field, configurationsList) => {
  const elementFound = configurationsList.find(
    (conf) => conf.id_field === id_field
  );
  return elementFound;
};
